import { LineSwatch } from '../../components/line.swatch';
import { addStyles } from '../../components/theme';
import { m, type MithrilVNode } from '../../mithril';
import { classNames } from '../../util/classnames';
import {
	type LegendItem,
	legendItemLabel,
	type LegendSwatch,
	LEGEND_ITEMS,
} from '../topological.editor.map/map.legend';
import {
	type PoleAccuracy,
	poleMeasurementAccuracyTypes,
	TopologicalEditorPointCSS,
} from '../topological.editor.map/map.point/map.point';
import { CSS, Style } from './map.mode.legend.style';

addStyles(Style);

function lineIcon(color: string): MithrilVNode {
	return m('div', { className: CSS.legendIconLine, style: `background-color: ${color}` });
}

function pointIcon(accuracy: PoleAccuracy, selected: boolean = false): MithrilVNode {
	return m('div', {
		className: classNames(TopologicalEditorPointCSS.container, poleMeasurementAccuracyTypes[accuracy], {
			[TopologicalEditorPointCSS.isSelected]: selected,
		}),
	});
}

function swatchIcon(swatch: LegendSwatch): MithrilVNode {
	switch (swatch.kind) {
		case 'line':
			return lineIcon(swatch.color);
		case 'point':
			return pointIcon(swatch.accuracy, swatch.selected);
		case 'collectionLabel':
			return m(
				'div',
				{ className: classNames(TopologicalEditorPointCSS.title, CSS.legendCollectionLabelOverride) },
				'abc'
			);
		case 'lineStyle':
			return LineSwatch.view({ symbol: swatch.symbol, width: 32, height: 12 });
	}
}

export const MapModeLegend = {
	view(extraItems: LegendItem[] = []) {
		return m(
			'div',
			{ className: CSS.container },
			[...LEGEND_ITEMS, ...extraItems].map((item) =>
				m('div', { className: CSS.legendItem }, [
					m('div', { className: CSS.legendIcon }, swatchIcon(item.swatch)),
					m('div', { className: CSS.legendText }, legendItemLabel(item)),
				])
			)
		);
	},
};
